<wun-filter ngSkipHydration [isGallery]="isGallery()" [isArtist]="true" #filter></wun-filter>
<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 xl:gap-6 p-6 main">
  @for (artist of artists() || []; track artist.id) {
    <div class="flex flex-col justify-between overflow-hidden gap-6 h-96">
      @let media = artist.cover;
      @if (media) {

        <a class="flex h-full items-center overflow-hidden justify-center bg-slate-50"
           [routerLink]="'./' + artist.id">
          <img alt="" class="object-cover w-auto cursor-pointer"
               priority
               [width]="media.width" [height]="media.height" [ngSrc]="media.url"/>
        </a>

      } @else {
        <a class="flex h-full items-center overflow-hidden justify-center bg-slate-50"
           [routerLink]="'./' + artist.id">
          <img alt="" class="object-cover w-auto cursor-pointer"
               [width]="300" [height]="300" src="fallback.png"/>
        </a>
      }
      <div class="flex flex-col gap-1.5">
        <a [routerLink]="['./', artist.id]" class="text-2xl font-light">
          @if (artist.displayNamePreference === 'NICKNAME' && (artist.nickname || artist.username)) {
            {{ artist.nickname || artist.username }}
          } @else {
            {{ artist.firstName }}
            {{ artist.lastName }}
          }

        </a>
        <div class="flex gap-2 items-baseline">
          <wun-icon-map-pin-light wunIcon="w-[8px]"/>
          <div class="truncate text-lg font-light">
            {{ artist.city }}
          </div>
        </div>
        <div>
          <wun-like-button [artistId]="artist.id" [likeId]="$any(artist).likeId" [likeCount]="artist.likeCount"/>
        </div>
      </div>

    </div>
  }
</div>
